import normalizeCta from '@models/CTA'
import normalizeImage from '@models/Image'

const Slider = ({ slides }) => {
  const normalizedSlides = slides.map((slide) => {
    return {
      tagline: slide.tagline,
      title: slide.title,
      paragraph: slide.paragraph,
      image: normalizeImage(slide.image),
      bulletPoints: slide.bulletPoints,
      ctaPrimary: normalizeCta(slide.ctaPrimary),
      ctaSecondary: normalizeCta(slide.ctaSecondary),
      variant: slide.variant,
      theme: slide.theme,
      video: slide.video,
    }
  })

  const normalizedTheme = normalizedSlides.length > 0 ? normalizedSlides[0].theme : 'white'
  const normalizedData = {
    theme: normalizedTheme,
    slides: normalizedSlides,
  }

  return normalizedData
}

export default Slider
